import { Component, OnInit } from "@angular/core";
import { Routes, Router, RouterModule } from "@angular/router";

import { LoginService } from "../../services/login.service";

import { CommonService } from "../../services/common.service";
import { AppSettings } from "../../appSettings";
declare var jquery: any;
declare var $: any;
@Component({
  selector: "app-managesellbuyinternetlife",
  templateUrl: "./managesellbuyinternetlife.component.html",
  styleUrls: ["./managesellbuyinternetlife.component.css"],
})
export class ManagesellbuyinternetlifeComponent implements OnInit {
  getinternetlifelistbyuserRestApiUrl: string =
    AppSettings.getinternetlifelistbyuser;
  model: any = {};
  userinternetlifelist: Array<Object>;
  historyList: Array<any> = [];
  showkeylengthError: boolean=false;
  websiteurl: string = AppSettings.USER_TEMPLATE;
  constructor(
    private loginService: LoginService,
    private CommonService: CommonService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loginService.localStorageData();
    this.model.currentUserID = localStorage.getItem("currentUserID");
    this.model.usertype = localStorage.getItem("usergroup");
    this.CommonService.insertdata(
      this.getinternetlifelistbyuserRestApiUrl,
      this.model
    ).subscribe((res) => {
      this.userinternetlifelist = res.result;
      this.loginService.viewCommontdataTable(
        "marketmgers_table",
        "marketmgers_table"
      );
    });
    this.loginService.viewsActivate();
    //find and remove in class in modal-backdrop fade in
    $(".modal-backdrop").removeClass("modal-backdrop fade in");
  }

  viewHistory(user_package_block_id) {
    this.model.user_package_block_id = user_package_block_id;
    this.model.currentUserID = localStorage.getItem("currentUserID");
    console.log("viewHistory-->", user_package_block_id);
    //implement api call getinternetlifesalehistory
    this.CommonService.insertdata(
      AppSettings.getinternetlifesalehistory,
      this.model
    ).subscribe((res) => {
      console.log("getinternetlifesalehistory api res-->", res);
      if (res.status == 0) {
        console.log("result-->", res.saleHistoryList);
        this.historyList = res.saleHistoryList;
        // Show the modal using jQuery
        $("#historyModal").modal("show");
      } else {
        console.log("No history found");
        this.historyList = [];
        $("#historyModal").modal("show");
      }
    });
  }

  enforceMin(event: any) {
    const value = event.target.value;
    if (value < 30) {
      event.target.value = 30;
      this.model.sell_price = 30;
    }
  }
  enforceMinbtn(sell_price: number) {
    if (sell_price < 30) {
      this.model.sell_price = 30;
    }
  }

  validateKeyLength() {
    console.log("validateKeyLength-->", this.model.new_life_key);
    if(this.model.new_life_key.length<6){
      this.showkeylengthError=true;
    }
     else{
      this.showkeylengthError=false;
    }
  }

  showPriceUpdate(user_package_block_id, sell_price) {
    this.model.user_package_block_id = user_package_block_id;
    this.model.currentUserID = localStorage.getItem("currentUserID");
    this.model.sell_price = sell_price;
    $("#priceUpdateModal").modal("show");
  }

  updatePriceInternetLife(user_package_block_id, sell_price) {
    this.model.user_package_block_id = user_package_block_id;
    this.model.currentUserID = localStorage.getItem("currentUserID");
    this.model.sell_price = sell_price;
    console.log("updatePriceInternetLife", user_package_block_id);
    swal({
      title: "Are you sure?",
      text: `Do you want to update the price?`,
      icon: "warning",
      buttons: ["Cancel", "Yes"],
      dangerMode: true,
    }).then((willProceed) => {
      if (willProceed) {
        this.CommonService.insertdata(
          AppSettings.update_internetlife_price,
          this.model
        ).subscribe((res) => {
          console.log("update_internetlife_price api res-->", res);
          if (res.status == 1) {
            swal("", res.message, "success").then(() => {
              //after success close modal
              $("#priceUpdateModal").modal("hide");
              // this.ngOnInit();
              //redirect to same page
              // this.router.navigate(['/manageinternetlife']);
              this.CommonService.insertdata(
                this.getinternetlifelistbyuserRestApiUrl,
                this.model
              ).subscribe((res) => {
                this.userinternetlifelist = res.result;
                this.loginService.viewCommontdataTable(
                  "marketmgers_table",
                  "marketmgers_table"
                );
              });
            });
          } else {
            swal("Error", res.message, "error");
          }
        });
      }
    });
  }

  activateInternetLife(user_package_block_id,website) {
    console.log("activateInternetLife-->", user_package_block_id);
    this.model.user_package_block_id = user_package_block_id;
    this.model.currentUserID = localStorage.getItem("currentUserID");
    this.model.activate_website=website;
    
     $("#activateModal").modal("show");
  }

  activateInternetLifeConfirm() {
    if(this.model.new_life_key.length<6){
      this.showkeylengthError=true;
      return;
    }
    console.log("activateInternetLifeConfirm-->", this.model);  
    this.CommonService.insertdata(
      AppSettings.activate_internetlife,
      this.model
    ).subscribe((res) => {
      console.log("activate_internetlife api res-->", res);
      if (res.status == 1) {
        swal("", res.message, "success").then(() => {
          //after success close modal
          $("#activateModal").modal("hide");
          this.CommonService.insertdata(
              this.getinternetlifelistbyuserRestApiUrl,
              this.model
            ).subscribe((res) => {
              this.userinternetlifelist = res.result;
              this.loginService.viewCommontdataTable(
                "marketmgers_table",
                "marketmgers_table"
              );
            });
          //redirect to same page
          // this.router.navigate(['/manageinternetlife']);
        });
      } else {
        swal("Error", res.message, "error");
      }
    });
  }

  deleteInternetLife(user_package_block_id) {
    console.log("deleteInternetLife-->", user_package_block_id);
    this.model.user_package_block_id = user_package_block_id;    
    this.model.currentUserID = localStorage.getItem("currentUserID");
    this.model.usertype = localStorage.getItem("usergroup");
    swal({
      title: "Are you sure?",
      text: `Do you want to delete this Internet Life?`,
      icon: "warning",
      buttons: ["Cancel", "Yes"],
      dangerMode: true,
    }).then((willProceed) => {
      if (willProceed) {
        this.CommonService.insertdata(
          AppSettings.delete_internet_life,
          this.model
        ).subscribe((res) => {
          console.log("delete_internetlife api res-->", res);
          if (res.status == 1) {
            swal("", res.message, "success").then(() => {              
              this.CommonService.insertdata(
                this.getinternetlifelistbyuserRestApiUrl,
                this.model
              ).subscribe((res) => {
                this.userinternetlifelist = res.result;
                this.loginService.viewCommontdataTable(
                  "marketmgers_table",
                  "marketmgers_table"
                );
              });
            });
          } else {
            swal("Error", res.message, "error");
          }
        });
      }
    });
  }
}
